<!-- 选题变更申请 -->
<template>
  <svg
    t="1748246891563"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="33318"
    width="200"
    height="200"
  >
    <path
      d="M149.333333 64h213.333334a85.333333 85.333333 0 0 1 85.333333 85.333333v213.333334a85.333333 85.333333 0 0 1-85.333333 85.333333H149.333333a85.333333 85.333333 0 0 1-85.333333-85.333333V149.333333a85.333333 85.333333 0 0 1 85.333333-85.333333z m512 512h213.333334a85.333333 85.333333 0 0 1 85.333333 85.333333v213.333334a85.333333 85.333333 0 0 1-85.333333 85.333333H661.333333a85.333333 85.333333 0 0 1-85.333333-85.333333V661.333333a85.333333 85.333333 0 0 1 85.333333-85.333333z m225.898667-245.205333a32 32 0 0 1 60.202667 21.653333l-42.666667 118.592a32 32 0 0 1-38.528 20.053333l-124.8-34.048a32 32 0 0 1 16.810667-61.738666l64.917333 17.706666c-73.429333-144.234667-177.258667-220.586667-313.792-231.786666a32 32 0 1 1 5.248-63.786667c154.965333 12.714667 275.178667 97.813333 358.4 252.821333l14.208-39.466666zM136.746667 693.205333A32 32 0 1 1 76.586667 671.573333l42.666666-118.592a32 32 0 0 1 38.528-20.053333l124.8 34.048a32 32 0 0 1-16.810666 61.738667l-64.917334-17.706667c31.466667 61.802667 68.501333 111.104 111.189334 148.117333 57.002667 49.472 124.309333 77.226667 202.602666 83.669334a32 32 0 1 1-5.248 63.786666c-90.538667-7.424-169.386667-39.616-235.946666-96.234666-47.146667-40.106667-87.978667-92.373333-122.453334-156.586667l-14.208 39.466667z"
      fill="#FF6033"
      p-id="33319"
    />
  </svg>
</template>
